<!-- <div class="row mb-3">
  <div *ngIf="!readonly" class="col-md-4" style="background-color:#D7D7D7; font-weight:600;">
    All documents marked with "*" must be uploaded in order for request to be submitted
  </div>

</div> -->
<!-- <div *ngIf="!readonly && !isAdditionalUpload" class="row">
  <div class="col-md-12 mb-3 form-group">
    <button class="btn btn-outline-primary" ngbTooltip="Click to upload existing documents from TMT profile"
      [disabled]="!canAutoUpload || isVisaApprover" (click)="pullDocsFromEmployeProfile()">
      Upload document from TMT profile
    </button>
  </div>
  <div class="col-md-12 mb-3 form-group">
    <button class="btn btn-outline-primary" (click)="AdditionalDocReq()"
      *ngIf="model.status.value !== ImmigrationStatusTypes.DRAFT && model.status.value !== ImmigrationStatusTypes.DECLINED && model.status.value !== ImmigrationStatusTypes.WITHDRAWN && model.status.value !== ImmigrationStatusTypes.COMPLETED">
      Additional document request
    </button>
  </div>
</div> -->
<div class="row mb-3">
  <div class="col-md-12 mb-3 form-group">
    <span  ngbTooltip="Click to upload existing documents from TMT profile">
    <button *ngIf="!isAdditionalUpload" class="btn btn-outline-primary mt-2" [disabled]="!canAutoUpload || isVisaApprover"
      (click)="pullDocsFromEmployeProfile()">
      Upload document from TMT profile
    </button>
    </span>
    <button *ngIf="isEmiratesID" class="btn button-padding btn-outline-primary me-1 float-end" eosDebounce
      (debounceClick)="downloadEmiratesID()"><img *ngIf="!showFormSpinner" style="height:19px;padding-bottom:4px;"
        src="design/images/download.svg">Download Emirates ID form</button>

    <a *ngIf="cicpavisa" class="btn button-padding btn-outline-primary me-1 float-end"
      href="http://www.cicpa.ae/en/CNIAServices/SecurityPermits.aspx" target="_blank"><img *ngIf="!showFormSpinner"
        style="height:19px;padding-bottom:4px;" src="design/images/download.svg">Download CICPA form</a>

    <span *ngIf="showFormSpinner" class="spinner m-3 down_img doc-spin"></span>
  </div>

  <div class="col-md-12">
    <span style="font-weight:bolder;">Documents section</span><br>
    <span>All documents marked with "*" must be uploaded in order for request to be
      submitted. Documents without asterisk (*) are optional.</span><br>
    <span>Please upload any one of the documents marked with a "#".</span><br>
    <span>Number of Mandatory documents to be uploaded - <b>{{pendingCount}}</b></span><br>
  </div>
</div>
<form name="form" class="needs-validation" #f="ngForm" novalidate>
  <fieldset>
    <div class="row brd-b">
      <div class="col-12">
        <div *ngIf="!isAdditionalUpload" style="margin-bottom: 2px;">
          <button [ngStyle]="{'background-color': allDoc ?'#D7D7D7':'transparent'}"
            class="btn button-padding btn-outline-primary me-1" (click)="getfileGrid(1)">All <span class="oval"
              style="background-color: #282836;">{{totalCount}}</span></button>
          <button [ngStyle]="{'background-color': uploadedDoc ?'#D7D7D7':'transparent'}"
            class="btn button-padding btn-outline-primary me-1" (click)="getfileGrid(2)">Uploaded <span class="oval"
              style="background-color: #168736;">{{uploadedCount}}</span></button>
          <button [ngStyle]="{'background-color': pendingDoc ?'#D7D7D7':'transparent'}"
            class="btn button-padding btn-outline-primary me-1" (click)="getfileGrid(3)">Upload pending <span
              class="oval" style="background-color: #F76900;">{{pendingAllCount}}</span></button>
          <!-- <button class="btn btn-outline-primary me-2 float-end">Submit</button> -->
          <div class="float-end form-check">
            <input type="checkbox" class="form-check-input" id="mandatoryCheckbox" (click)="mandatoryCheck()">
            <label class="form-check-label" for="mandatoryCheckbox">Filter mandatory documents</label>
          </div>
          <button
            *ngIf="model.status.value !== ImmigrationStatusTypes.DRAFT && model.status.value !== ImmigrationStatusTypes.DECLINED && model.status.value !== ImmigrationStatusTypes.WITHDRAWN && model.status.value !== ImmigrationStatusTypes.COMPLETED"
            class="btn button-padding btn-outline-primary me-1 float-end" eosDebounce
            (debounceClick)="AdditionalDocReq()"><img style="height:19px;padding-bottom:4px;"
              src="design/images/doc-search-alt.svg"> Additional document request</button>
          <button class="btn button-padding btn-outline-primary me-1 float-end" eosDebounce
            (debounceClick)="multipleDocsShare()"><img style="height:19px;padding-bottom:4px;"
              src="design/images/share-2.png"> Share documents</button>
        </div>
        <div>
            <button class="btn button-padding btn-outline-primary me-1 float-end" eosDebounce
            (debounceClick)="downloadAll()"><img *ngIf="!showSpinner" style="height:19px;padding-bottom:4px;"
              src="design/images/download.svg">{{ docType }}</button>
          <span *ngIf="showSpinner" class="spinner m-3 down_img doc-spin"></span>
        </div>
        <div class="table-resp table-responsive document-view-scroll mb-3">
          <table class="table table-bordered">
            <tr class="stick-on-top">
              <th style="width:30%;">Type of document</th>
              <th style="width:25%;">CM9 Document name</th>
              <th style="width:20%;">Description</th>
              <th style="width:8%;">Date</th>
              <th style="width:15%;"></th>
            </tr>
            <tr *ngFor="let doc of gridFiles; let i = index;" style="height: 20px !important">

              <td>
                {{doc.documentTypeName+' '+ (doc.isMandatory == 1 ?'*':doc.mandatoryType > 0 ? '#':
                '')}}
                <div class="float-end" *ngIf="getDocValidationMessages(doc.documentChecks).length > 0">
                  <ng-template #content>
                    <table class="table">
                      <th> Status </th>
                      <th> Message </th>
                      <tr *ngFor="let errors of getDocValidationMessages(doc.documentChecks)">
                        <td> {{errors.errorType}} </td>
                        <td> {{errors.errorMessage}} </td>
                      </tr>

                    </table>
                  </ng-template>
                  <img style="margin-left:-900%" src="design/images/Icons-Alerts-ic_warning.png" [ngbPopover]="content"
                    triggers="mouseenter:mouseleave" popoverTitle="Specifications failed" />
                </div>
              </td>
              <td style="padding:0"><div class="dot"
                  [ngStyle]="{'background-color': doc.isUploaded ?'#168736':'#F76900'}"></div>
                 {{' '+getDocNameForGrid(doc)+' '+ (doc.isMandatory == 1 ?'*':'')}}

                  <!-- {{this.model.docPrefix
                ? ' '+getDocName(doc.documentName)+' '+ (doc.isMandatory == 1 ?'*':''):
                ' '+doc.documentName.replace("GPN_", '')+' '+ (doc.isMandatory == 1 ?'*':'')}} -->
              </td>
              <td><input name="doc.{{i}}.desc" style="height: 20px" type="text" class="form-control form-control-sm custom-bordered-input"
                  [(ngModel)]="doc.description"></td>
              <td *ngIf="doc.modifiedDate == null">{{doc.createdDate | localDate: 'dd-MM-yyyy'}}</td>
              <td *ngIf="doc.modifiedDate != null">{{doc.modifiedDate | localDate: 'dd-MM-yyyy'}}</td>
              <td *ngIf="!doc.isUploaded || doc.isEditMode">

                <div>
                  <input [disabled]="disableUpload" #fileControl name="fileName" type="file"
                    (change)="fileSelected($event.target.files)" #fileName [accept]="fileBrowserAllowedTypes"
                    style="display: none;">

                  <input #fileField type="text" readonly [value]="selectedFileName" style="display: none;"
                    [ngClass]="{ 'is-invalid': (fileName.dirty || fileName.touched || f.submitted) && !selectedDocument && !doc.isEditMode || ifDocNotValid }"
                    required />

                  <div style="text-align: right;">

                    <button type="button" *ngIf="doc.isEditMode" (click)="closeEdit(doc)" class="btn-close" aria-label="Close" title="Close Edit"></button>

                    <img *ngIf="!readonly" class="cursor" src="design/images/attachment_1.svg" (click)="browseFile(doc)"
                      ngbTooltip={{doc.instruction}} tooltipClass="delegate-tooltip" placement="left" />
                  </div>
                </div>
              </td>
              <td *ngIf="doc.isUploaded && !doc.isEditMode">
                <div>
                  <div style="text-align: right;">
                    <a (click)="preview(doc)" ngbTooltip="View">
                      <img class="cursor" src="design/images/eye-alt.svg" />
                    </a>
                    <a *ngIf="!readonly" ngbTooltip="Edit" (click)="edit(doc)">
                      <img class="cursor" src="design/images/edit-pencil.svg" />
                    </a>
                    <a (click)="downloadDocument(doc)">
                      <img class="cursor" src="design/images/download.svg" ngbTooltip="Download">
                    </a>
                    <a (click)="share(doc)" ngbTooltip="Share" *ngIf="!isAdditionalUpload">
                      <img class="ms-2 cursor" src="design/images/share-2.png" /></a>
                      <a *ngIf="!readonly && doc.synced" (click)="unlink(doc)" ngbTooltip="Cancel">
                        <img class=" ms-2 cursor" src="design/images/cancel.png" />
                      </a>
                    <a *ngIf="!readonly && !doc.synced" ngbTooltip="Delete" (click)="delete(doc)"><img class="cursor"
                        src="design/images/trash.svg" /></a>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
            <!-- prev code commented -->
      <!-- <div *ngIf="!readonly" class="col-md-4 brd-r">
        <div class="row">
          <div class="col-md-12 mb-3 form-group">
            <label for="documentTypeId">Type of document </label>
            <select name="documentTypeId" type="number" class="form-control form-control-sm"
              [(ngModel)]="fileDetails.documentTypeId" #documentTypeId="ngModel" (change)="setCMDocTypes()"
              [ngClass]="{ 'is-invalid': documentTypeId.invalid && (documentTypeId.dirty || f.submitted) }" required>
              <option [ngValue]="null">Select</option>
              
              <option *ngFor="let type of getdistinctDocTypes" [ngValue]="type.docTypeId"
                title="{{type.docTypeDisplayText +' '+ (type.isMandatory || type.mandatoryType > 0 ?'*':'')}}" [ngClass]="{'grey-color': isDocuploaded(type,'docType')}">
                {{ getDataTrim(type,50) }}
              </option>
            </select>
            <div *ngIf="documentTypeId.invalid" class="invalid-feedback">
              <div *ngIf="documentTypeId.errors.required">Document type is required</div>
            </div>
          </div>
          <div class="col-md-12 mb-3 form-group">
            <label for="documentNameId">CM9 document name</label>
            <select name="documentNameId" type="number" class="form-control form-control-sm"
              [(ngModel)]="selectedDocName" #documentName="ngModel" (change)="setCMDocInstruction()"
              [ngClass]="{ 'is-invalid': documentName.invalid && (documentName.dirty || f.submitted) }" required>
              <option [ngValue]="null">Select</option>
              <option *ngFor="let type of documentTypes" [ngValue]="type" [ngClass]="{'grey-color': isDocuploaded(type,'docNameId')}">
                {{replaceGPNwithCode(type.docNameDisplayText) +' '+ (type.isMandatory ?'*':'')}} 
              </option>
            </select>
            <div *ngIf="documentName.invalid" class="invalid-feedback">
              <div *ngIf="documentName.errors.required">Document name is required</div>
            </div>
          </div>

          <div class="col-md-12 mb-3 form-group">
            <label>Description</label>           
            <input name="description" type="text" [(ngModel)]="fileDetails.description"
              class="form-control form-control-sm" #description="ngModel" [required]="fileDetails.documentNameId==6083"
              [ngClass]="{ 'is-invalid':description.invalid && (description.dirty ||  f.submitted) }" maxlength="100">
          
            <div *ngIf="description.invalid" class="invalid-feedback">
              <div *ngIf="description.errors.required">Description is required</div>
              <div *ngIf="fileDetails.description && description.invalid">
                Enter valid description
              </div>
            </div>
          </div>
          <div *ngIf="docInstruction" class="col-md-12 mb-3">
            <label>Document upload instruction</label>
            <p><span class="doc-instruction" role="textbox" contenteditable>{{docInstruction}}</span></p>
          </div>
          <div class="col-md-12 mb-3 form-group">
            <label>Upload file</label>
            <div class="input-group mb-3">
              <input [disabled]="disableUpload" #fileControl name="fileName" type="file"
                (change)="fileSelected($event.target.files)" #fileName [accept]="fileBrowserAllowedTypes"
                style="display: none;">

              <input #fileField type="text" class="form-control form-control-sm readonly-date" readonly
                [value]="selectedFileName"
                [ngClass]="{ 'is-invalid': (fileName.dirty || fileName.touched || f.submitted) && !selectedDocument && !editMode || ifDocNotValid }"
                required />

              <div class="input-group-append">
                <button [disabled]="disableUpload" type="button" (click)="browseFile()" class="btn-outline-primary">
                  Browse
                </button>
              </div>
              <div class="invalid-feedback">
                
                <span *ngIf="f.submitted && !selectedDocument && !editMode">
                  File is required
                </span>
              </div>
            </div>

          </div>

          <div class="col-md-12 mb-3 text-center form-group">
            <button *ngIf="!disableUpload" type="button" (click)="clear(f)" class="btn btn-outline-primary me-2">
              Clear
            </button>
            <button [disabled]="disableUpload" (click)=" uploadDoc(f)" class="btn btn-secondary">
              <span *ngIf="!disableUpload">Upload</span>
              <span *ngIf="disableUpload" class="spinner m-3"></span>
            </button>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12" *ngIf="validationList.length > 0">
            <div class="error-list">

              <div class="card">
                <p class="card-header" (click)="isCollapsed = ! isCollapsed" [attr.aria-expanded]="!isCollapsed"
                  aria-controls="collapseExample">
                  Specifications failed ({{validationList.length}})
                  <img *ngIf="!isCollapsed" src="design/images/minus.svg">
                  <img *ngIf="isCollapsed" src="design/images/plus.svg">
                  </p>
                <div class="card-body collapse show" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">

                  <ul>
                    <li *ngFor="let errors of validationList">

                      <img *ngIf="errors.errorType=='Fail'" src="design/images/Icon material-error.svg" />
                      <img *ngIf="errors.errorType=='Warning'" src="design/images/warning.svg" />

                      <p> {{errors.errorMessage}}</p>

                    </li>

                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">

        <h6 class="dochead"><strong>Uploaded files</strong></h6>
        <div *ngIf="cicpavisa">
          <a class="btndownall cursor" style="color: #336699;"
             href="http://www.cicpa.ae/en/CNIAServices/SecurityPermits.aspx" target="_blank">
            Download CICPA form
          </a>
          <div class="ax_default">
            <img *ngIf="!showSpinner" class="down_img" src="design/images/download.png" style="padding-left: 10px">
            <span *ngIf="showSpinner" class="spinner m-3 down_img doc-spin"></span>
          </div>
        </div>
        <div *ngIf="isEmiratesID">
          <a eosDebounce class="btndownall cursor" style="color: #336699;" (debounceClick)="downloadEmiratesID()">
            Download Emirates ID form
          </a>
          <div class="ax_default">
            <img *ngIf="!showSpinner" class="down_img" src="design/images/download.png" style="padding-left: 10px">
            <span *ngIf="showSpinner" class="spinner m-3 down_img doc-spin"></span>
          </div>
        </div>
        <div *ngIf="!isAdditionalUpload">
          <a class="btndownall cursor" style="color: #336699;" (click)="multipleDocsShare()">
            Share documents
          </a>
          <div class="btnshareall">
            <img class="down_img" src="design/images/share-all.png">
          </div>
        </div>
        <div *ngIf="!isAdditionalUpload">
          <a eosDebounce class="btndownall cursor" style="color: #336699;" (debounceClick)="downloadAll()">
            {{ docType }}
          </a>

          <div class="ax_default">
            <img *ngIf="!showSpinner" class="down_img" src="design/images/download.png">
            <span *ngIf="showSpinner" class="spinner m-3 down_img doc-spin"></span>
          </div>
          </div>
          <div class="table-resp table-responsive document-view-scroll mb-3">
            <table class="table table-bordered">
              <tr class="stick-on-top">
                <th>Type of document</th>
                <th>CM9 document name</th>
                <th>Description</th>
                <th width="120px">Date of upload</th>
                <th width="140px">Attachment</th>
                <th>Attachment type</th>
                <th *ngIf="!readonly" width="60px">Edit</th>
                <th *ngIf="!readonly" width="60px">Delete</th>
              </tr>
              <tr *ngFor="let doc of uploadedFiles">
                <td>
                  {{doc.documentType.displayText}}
                  <div class="float-end" *ngIf="getDocValidationMessages(doc.documentChecks).length > 0">
                    <ng-template #content>
                      <table class="table">
                        <th> Status </th>
                        <th> Message </th>
                        <tr *ngFor="let errors of getDocValidationMessages(doc.documentChecks)">
                          <td> {{errors.errorType}} </td>
                          <td> {{errors.errorMessage}} </td>
                        </tr>

                      </table>
                    </ng-template>
                    <img src="design/images/Icons-Alerts-ic_warning.png" [ngbPopover]="content"
                         triggers="mouseenter:mouseleave" popoverTitle="Specifications failed" />
                  </div>
                </td>

                <td>
                  {{ doc.documentName | cmNineDocName: model.docPrefix}}
                </td>
                <td>{{doc.description}}</td>
                <td *ngIf="doc.modifiedDate == null">{{doc.createdDate | localDate: 'dd-MM-yyyy'}}</td>
                <td *ngIf="doc.modifiedDate != null">{{doc.modifiedDate | localDate: 'dd-MM-yyyy'}}</td>
                <td>
                  <a (click)="downloadDocument(doc)" ngbTooltip="Download">
                    <img class="cursor" src="design/images/file-attach.png" />
                  </a>
                  <a (click)="preview(doc)" ngbTooltip="Preview">
                    <img class="ml-2 cursor" src="design/images/show.png" />
                  </a>
                  <a (click)="share(doc)" ngbTooltip="Share" *ngIf="!isAdditionalUpload">
                    <img class="ml-2 cursor" src="design/images/share-2.png" />
                  </a>
                </td>
                <td>{{ doc.fileName.slice((doc.fileName.lastIndexOf(".") + 1)) }}</td>

                <td *ngIf="!readonly">
                  <a *ngIf="!doc.synced  &&  isEditable(doc)" (click)="edit(doc, f)" ngbTooltip="Edit">
                    <img class="cursor" src="design/images/file-edit.png" />
                  </a>
                </td>

                <td *ngIf="!readonly">

                  <a *ngIf="doc.synced" (click)="unlink(doc)" ngbTooltip="Cancel">
                    <img class="cursor" src="design/images/cancel.png" />
                  </a>
                  <a *ngIf="!doc.synced && isEditable(doc)" (click)="delete(doc)" ngbTooltip="Delete">
                    <img class="cursor" src="design/images/delete.png" />
                  </a>
                </td>
              </tr>
            </table>
          </div>
        </div> -->
      <!-- prev code commented end -->
    </div>
  </fieldset>
</form>
